const { Core, Events } = Global;

const ACTIVE_CLASS = '!active';

customElements.define('doto-cart-toast', class extends Core {
    render() {
        this._hideTimer = null;
        this._boundClose = this._close.bind(this);

        this.addEventListener('click', this._handleClick.bind(this));
        this._enableCartNotifications();
        this._muteDrawer();
        this.sub(Events.CART_UPDATE, this._handleCartUpdate, { global: true });
    }

    disconnectedCallback() {
        window.clearTimeout(this._hideTimer);

        if (super.disconnectedCallback) {
            super.disconnectedCallback();
        }
    }

    async _enableCartNotifications() {
        await customElements.whenDefined('cart-provider');
        this.pub(Events.CART_NOTIFICATIONS_ENABLING);
    }

    async _muteDrawer() {
        await customElements.whenDefined('cart-drawer');
        this.pub(Events.CART_DRAWER_MUTE);
    }

    _handleCartUpdate({ req }) {
        if (req !== 'cartAdd') return;

        window.clearTimeout(this._hideTimer);

        /* cart-live-region updates from the same CART_UPDATE event.
           Waiting one frame ensures the refreshed product title/image is painted. */
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                this.classList.add(ACTIVE_CLASS);
                this._scheduleClose();
            });
        });
    }

    _handleClick(event) {
        if (event.target.closest('[data-doto-cart-toast-close]')) {
            this._close();
        }
    }

    _scheduleClose() {
        const duration = Number(this.dataset.duration) || 4000;

        this._hideTimer = window.setTimeout(() => {
            this._close();
        }, duration);
    }

    _close() {
        window.clearTimeout(this._hideTimer);
        this.classList.remove(ACTIVE_CLASS);
    }
});
